import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Coins, Sparkles, X } from "lucide-react";
import { api } from "@/lib/api";
import { isNativeIOS } from "@/lib/nativePush";

const KEY = "pandax_intro_bonus_nudge_dismissed_at";
const SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;

// Feed nudge for members who haven't bought coins yet: their 15% welcome bonus is waiting. Website only.
export default function IntroBonusNudge() {
  const [status, setStatus] = useState(null);
  const [hidden, setHidden] = useState(() => {
    try { const t = Number(window.localStorage.getItem(KEY) || 0); return t && Date.now() - t < SNOOZE_MS; } catch { return false; }
  });

  useEffect(() => {
    if (hidden || isNativeIOS()) return;
    api.get("/payments/intro-bonus").then(({ data }) => setStatus(data)).catch(() => setStatus({ eligible: false }));
  }, [hidden]);

  if (hidden || isNativeIOS() || !status?.eligible) return null;
  const dismiss = () => { setHidden(true); try { window.localStorage.setItem(KEY, String(Date.now())); } catch { /* noop */ } };
  const ex = status.example || {};

  return (
    <div className="relative mb-6 border border-emerald-400/30 bg-emerald-400/5 p-4 sm:pr-10 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4" data-testid="intro-bonus-nudge">
      <div className="flex items-center gap-3 pr-8 sm:pr-0 sm:contents">
      <div className="h-11 w-11 shrink-0 grid place-items-center border border-emerald-400/40 bg-black/40 text-emerald-300"><Coins size={20} /></div>
      <div className="min-w-0 flex-1">
        <div className="text-[10px] uppercase tracking-[0.3em] text-emerald-400/80 flex items-center gap-1.5"><Sparkles size={11} /> Welcome bonus</div>
        <div className="font-display text-xl leading-tight text-white" data-testid="intro-bonus-nudge-text">Your {status.pct}% welcome bonus is waiting</div>
        <div className="text-[11px] text-zinc-400 mt-0.5">
          Starter pack only: {Number(ex.coins || 0).toLocaleString()} + {Number(ex.bonus || 0).toLocaleString()} bonus coins for ${((ex.amount_cents || 0) / 100).toFixed(2)}.
        </div>
      </div>
      </div>
      <Link to="/coins" data-testid="intro-bonus-nudge-cta" className="shrink-0 text-xs uppercase tracking-widest px-4 py-2.5 bg-emerald-400 text-black hover:bg-emerald-300 transition-colors text-center">See packs</Link>
      <button type="button" onClick={dismiss} aria-label="Dismiss" data-testid="intro-bonus-nudge-dismiss" className="absolute top-1 right-1 h-9 w-9 grid place-items-center text-zinc-500 hover:text-white"><X size={14} /></button>
    </div>
  );
}
